module.exports = __webpack_public_path__ + "static/media/maankaytto.60a1f664.jpg";